import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import hilux from "../../../../assets/info/hilux-4wd-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const ToyotaHilux = () => {
  useSmallNav("Toyota Hilux 4WD");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Toyota Hilux 4WD"} bolder />
        <InfoHero image={hilux} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Zdobądź najlepsze sportowe zawieszenie do swojej Toyoty Hilux"
              }
            />
            <p>
              Zawieszenie Trak Ryder 4WD reprezentuje wieloletni rozwój
              techniczny i zapewnia nowy poziom jazdy i komfortu właścicielowi
              Hiluxa z napędem na 4 koła. Zawieszenie Pedders Trak Ryder składa
              się z setek wysokiej jakości komponentów, z których każdy ma na
              celu poprawę prowadzenia i obsługi określonych pojazdów w
              określony sposób.
            </p>
            <p>
              Sukces układu zawieszenia Pedders Trak Ryder 4WD nie zależy od
              samego produktu. Trak Ryder to system dostosowany do
              indywidualnych potrzeb, a jego skuteczność w dużej mierze wynika z
              faktu, że system można „zbudować na zamówienie”, aby pasował do
              każdego pojazdu z napędem 4x4. Dzięki Trak Ryderowi można cieszyć
              się wszystkimi wymagającymi cechami pojazdu terenowego z napędem
              na 4 koła, a jednocześnie zachować właściwości jezdne sedana.
              Właścicielom nowszych pojazdów Trak Ryder kładzie kres odwiecznemu
              kompromisowi posiadania napędu na 4 koła i konieczności
              rezygnowania z komfortu.
            </p>
            <p>
              Niezależnie od tego, czy chodzi o codzienną jazdę, zestawy do
              podnoszenia, holowanie i przewożenie ładunku, możesz mieć pewność,
              że Twój specjalista ds. zawieszeń Pedders w może dostosować układ
              zawieszenia Trak Ryder do Twoich potrzeb.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/FLQI_XYj4Bc"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5olMu1M-eJ8"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Toyota")
              .models.find((e) => e.display === "Hilux 4WD")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Toyota" model="Hilux 4WD" /> */}
      </Container>
    </section>
  );
};

export default ToyotaHilux;
